module.exports = __webpack_public_path__ + "assets/img/services3.e40b3d34.svg";